import React, {useEffect, useMemo, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import {UpdateData, CreateData, GetFilterContactSegment} from '../SegmentSlice/SegmentSlice'
import moment from 'moment'
import {getalltagsdata} from '../../Tags/TagSlice/TagsSlices'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useLazyGetGroupQuery} from '../../../../../../services/cellcast'
import {array, boolean} from 'yup'
import {start} from 'repl'

const CreateSegmentPopup = ({
  show,
  handleClose,
  segmentData,
  setSegmentData,
  setNewSegmentData,
  handleOpenContects,
}: any) => {
  const dispatch = useDispatch()
  const tagsData = useSelector((state: any) => state?.tags?.allTags?.data)
  const tagslist = useMemo(() => {
    if (Array.isArray(tagsData)) {
      return tagsData.filter((val: any) => val?.type !== 'list')
    }

    return []
  }, [tagsData])

  // handle group
  const [fetchGroup, {isLoading: isGroupLoading, data: group}] = useLazyGetGroupQuery({})

  const [error, setError] = useState<any>({})
  ////////range set
  const [startRange, setStartRange] = useState('')
  const [endRange, setEndRange] = useState('')
  // input value
  const [stringValue, setStringValue] = useState('')
  const [segName, setSegName] = useState<any>('')
  /////Datepicker state

  const [birthdayDate, setBirthdayDate] = useState({
    start: new Date(),
    end: new Date(),
  })

  const [SelectorOption, SetSelectorOrOption] = useState([
    {value: 'tags', label: 'Tags'},
    {value: 'createdAt', label: 'Join date'},
    {value: 'addedThrough', label: 'Sign up source'},
    {value: 'Birthday', label: 'Birthday'},
    // {value: 'Postal Code', label: 'Postal Code'},
    // {value: 'Postalcode', label: 'Postal Code'},
    {value: 'First Name', label: 'First Name'},
    {value: 'Last Name', label: 'Last Name'},
    {value: 'Address', label: 'Address'},
    {value: 'bounced', label: 'Bounced'},
    {value: 'click', label: 'Click (CT)'},
    {value: 'clickedAt', label: 'Time & Date Range of (CT)'},
    {value: 'Gender', label: 'Gender'},
  ])

  ///// relation between conditions
  const [AndOr, setAndOr] = useState<any>({relation1: '$or-1', relation2: '$or-2'})
  ////Condition array
  const [addCondition, setAddCondition] = useState<any>([
    {
      selector: {value: '', label: 'Select'},
      relation: {value: '', label: 'Select'},
      condition: '',
      conditionType: '',
    },
  ])
  const dbOptions: any[] =
    useSelector((state: any) => state?.subscriberData?.FieldName?.data?.fields) || []

  ///// get All tags list
  useEffect(() => {
    dispatch(getalltagsdata())
    fetchGroup(null)
  }, [])

  useEffect(() => {
    if (group && group.data) {
      const defaultSelectors = SelectorOption.map((el) => el.value)
      const dynamicSelectors = group.data.fields
        .filter((f) => !['Gender'].includes(f))
        .filter((f) => {
          return !defaultSelectors.includes(f)
        })

      if (dynamicSelectors.length > 0) {
        const tmpSelectors = [...SelectorOption]
        dynamicSelectors.forEach((el) => {
          tmpSelectors.push({
            value: el,
            label: ['Postal Code', 'Postalcode'].includes(el) ? 'Postal Code' : el,
          })
        })
        SetSelectorOrOption(tmpSelectors)
      }
    }
  }, [group])

  /////////EDIT logic to set all data
  useEffect(() => {
    if (segmentData?._id !== undefined) {
      let conditions = [
        segmentData?.condition1,
        segmentData?.condition2,
        segmentData?.condition3,
      ]?.filter((key: any) => key !== undefined)
      var finalArr = [...conditions]
      conditions?.map((key: any, index: number) => {
        var arr: any = []
        if (key?.selector == 'tags') {
          let option = tagslist?.map((val: any) => {
            key?.condition?.forEach(
              (key2: any) => key2 === val?._id && arr?.push({value: val?._id, label: val?.name})
            )
          })
          let val: any = {...finalArr[index]}

          //////////////////////////COndition set
          val[`condition`] = arr
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
        if (['createdAt', 'Birthday', 'clickedAt'].includes(key?.selector)) {
          let val: any = {...finalArr[index]}
          let date = key?.condition?.split('||')
          let date1 = date?.[0]?.replaceAll('/', '-')

          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find((val: any) =>
            date?.[0] !== date?.[1] ? val?.label == 'is in between' : val?.value == key?.relation
          )
          val['condition'] = {
            start: new Date(date?.[0]?.replaceAll('/', '-')),
            end: new Date(date?.[1]?.replaceAll('/', '-')),
          }

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }

        if (['Postal Code', 'Postalcode'].includes(key?.selector)) {
          let val: any = {...finalArr[index]}
          let data = key?.condition?.split('||')

          let relationOption =
            key?.relation == '$in' ? `Is ${key?.selector}` : `Not ${key?.selector}`
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find((val: any) =>
            data?.[0] !== data?.[1]
              ? val?.label.includes('in between')
              : val?.value == key?.relation
          )

          val['condition'] = {
            start: data[0],
            end: data[1],
          }

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }

        if (['bounced', 'click'].includes(key?.selector)) {
          let val: any = {...finalArr[index]}
          let data = key?.condition

          if (data.includes('||')) {
            data = key?.condition?.split('||')
          }
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)

          if (Array.isArray(data)) {
            val['relation'] = ConditionOptions?.[key?.selector]?.find((val: any) =>
              data?.[0] !== data?.[1]
                ? val?.label.includes('in between')
                : val?.value == key?.relation
            )
            val['condition'] = {
              start: data[0],
              end: data[1],
            }
          } else {
            val['relation'] = ConditionOptions?.[key?.selector]?.find(
              (val: any) => val?.value == key?.relation
            )
            val['condition'] = data
          }

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }

        if (['Last Name', 'First Name'].includes(key?.selector)) {
          let val: any = {...finalArr[index]}
          let relationOption =
            key?.relation == '$in' ? `Is ${key?.selector}` : `Not ${key?.selector}`
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          val['condition'] = key?.condition

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
        if (key?.selector == 'Address') {
          let val: any = {...finalArr[index]}

          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          val['condition'] = key?.condition

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
        if (key?.selector == 'addedThrough') {
          let val: any = {...finalArr[index]}
          // let relationOption =
          // key?.relation == '$eq' ? : `Not ${key?.selector}`
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          val['condition'] = {value: key?.condition, label: key?.condition?.toUpperCase()}

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }

        if (key?.selector == 'Gender') {
          let val: any = {...finalArr[index]}
          // let relationOption =
          // key?.relation == '$eq' ? : `Not ${key?.selector}`
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          val['condition'] = {
            value: key?.condition,
            label: key?.condition === 'M' ? 'Male' : 'Female',
          }

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }

        if (key?.isDynamicFilter) {
          let val: any = {...finalArr[index]}
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = DynamicConditionOptions?.[key?.conditionType]?.find(
            (val: any) => val?.value === key?.relation
          )

          if (val['conditionType'] === 'range' && val['condition'].includes('||')) {
            const conditions = val['condition'].split('||')
            const condition = {start: '', end: ''}
            if (conditions.length > 0) {
              condition.start = conditions[0]
            }

            if (conditions.length > 1) {
              condition.end = conditions[1]
            }

            val['condition'] = condition
          }
          
          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
      })

      setAndOr({
        relation1: `${segmentData?.relation1 || '$or'}-1`,
        relation2: `${segmentData?.relation2 || '$or'}-2`,
      })
      setAddCondition(finalArr)
      setSegName(segmentData?.name)
    }
  }, [segmentData])

  ///////EDIT logic END

  /////Logic to handle selector
  const handleChange = (e: any, index: any) => {
    const updatedData = [...addCondition]
    if (e?.value == 'tags') {
      updatedData[index] = {
        ...updatedData[index],
        [`selector`]: e,
        relation: {value: '', label: 'Select'},
        conditionType: 'array',
        condition: '',
        isDynamicFilter: false,
      }

      setAddCondition(updatedData)
    } else if (
      ['Birthday', 'Postal Code', 'Postalcode', 'createdAt', 'bounced', 'clickedAt'].includes(
        e?.value
      )
    ) {
      updatedData[index] = {
        ...updatedData[index],
        [`selector`]: e,
        relation: {value: '', label: 'Select'},
        conditionType: 'range',
        condition: null,
        isDynamicFilter: false,
      }
      setAddCondition(updatedData)
    } else if (
      ['First Name', 'Last Name', 'Address', 'addedThrough', 'click', 'Gender'].includes(e?.value)
    ) {
      updatedData[index] = {
        ...updatedData[index],
        [`selector`]: e,
        relation: {value: '', label: 'Select'},
        conditionType: 'string',
        condition: '',
        isDynamicFilter: false,
      }

      setAddCondition(updatedData)
    } else if (e?.value != '') {
      updatedData[index] = {
        ...updatedData[index],
        [`selector`]: e,
        relation: {value: '', label: 'Select'},
        conditionType: '',
        condition: '',
        isDynamicFilter: true,
      }

      setAddCondition(updatedData)
    } else if (e?.value == '') {
      updatedData[index] = {
        ...updatedData[index],
        [`selector`]: e,
        relation: {value: '', label: 'Select'},
        conditionType: '',
        condition: '',
        isDynamicFilter: false,
      }

      setAddCondition(updatedData)
    }
  }
  const handleChangeRelation = (e: any, index: any) => {
    const updatedData = [...addCondition]
    if (addCondition[index]?.selector?.value == 'tags') {
      updatedData[index] = {
        ...updatedData[index],
        relation: e,
      }
      setAddCondition(updatedData)
    } else if (
      ['Birthday', 'Postal Code', 'Postalcode', 'createdAt', 'clickedAt'].includes(
        addCondition[index]?.selector?.value
      )
    ) {
      updatedData[index] = {
        ...updatedData[index],
        relation: e,
      }
      setAddCondition(updatedData)
    } else if (['bounced', 'click'].includes(addCondition[index]?.selector?.value)) {
      const foundData = updatedData[index]

      if (e.value === '$in' && typeof foundData.condition != 'object') {
        foundData.condition = {
          start: foundData.condition,
          end: 0,
        }
      }

      if (e.value !== '$in' && typeof foundData.condition == 'object') {
        foundData.condition = foundData.condition?.start || 0
        foundData.conditionType = 'string'
      }

      if (e.value === '$in') {
        foundData.conditionType = 'range'
      } else {
        foundData.conditionType = 'string'
      }

      updatedData[index] = {
        ...foundData,
        relation: e,
      }

      setAddCondition(updatedData)
    } else if (
      ['First Name', 'Last Name', 'Address', 'addedThrough', 'Gender'].includes(
        addCondition[index]?.selector?.value
      )
    ) {
      updatedData[index] = {
        ...updatedData[index],
        relation: e,
      }
      setAddCondition(updatedData)
    } else if (addCondition[index].isDynamicFilter) {
      updatedData[index] = {
        ...updatedData[index],
        relation: e,
      }
      setAddCondition(updatedData)
    }
  }

  const handleChangeConditionType = (e: any, index: any) => {
    const updatedData = [...addCondition]

    updatedData[index] = {
      ...updatedData[index],
      conditionType: e.value,
      condition: e.value === 'range' ? {start: '', end: ''} : '',
    }
    setAddCondition(updatedData)
  }

  /////Multi tag selector logic
  const handlemultiselect = (e: any, index: number) => {
    let conditionData = [...addCondition]
    let val: any = conditionData[index]

    val[`condition`] = e
    conditionData.splice(index, 1)
    conditionData.splice(index, 0, val)

    setAddCondition(conditionData)
  }
  //// UPDAET OR CREATE LOGIC
  const handleSubmit = (e: any) => {
    e.preventDefault()
    let orAndCondition = {...AndOr}

    let finaldata: any = {
      name: segName,
    }
    if (addCondition?.length > 1) {
      finaldata.relation1 = AndOr?.relation1?.split('-')[0]
    }
    if (addCondition?.length > 2) {
      finaldata.relation1 = AndOr?.relation1?.split('-')[0]
      finaldata.relation2 = AndOr?.relation2?.split('-')[0]
    }

    let x = addCondition?.map((key: any, keyIndex: number) => {
      if (key?.selector?.value == 'tags') {
        let ids = key?.condition?.length > 0 ? key?.condition?.map((val: any) => val?.value) : []
        return {
          ...key,
          condition: ids,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }
      if (['createdAt', 'Birthday', 'clickedAt'].includes(key?.selector?.value)) {
        var Startdate = new Date(key?.condition?.start)

        // Get the year, month, and day components
        var startyear = Startdate.getFullYear()
        var startmonth = (Startdate.getMonth() + 1).toString().padStart(2, '0') // Month is zero-based, so we add 1
        var startday = Startdate.getDate().toString().padStart(2, '0')
        var enddate = new Date(key?.condition?.end || key?.condition?.start)

        // Get the year, month, and day components
        var endyear = enddate.getFullYear()
        var endmonth = (enddate.getMonth() + 1).toString().padStart(2, '0') // Month is zero-based, so we add 1
        var endday = enddate.getDate().toString().padStart(2, '0')

        return {
          ...key,
          condition: `${startyear}/${startmonth}/${startday}||${endyear}/${endmonth}/${endday}`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }

      if (['Postal Code', 'Postalcode'].includes(key?.selector?.value)) {
        return {
          ...key,
          condition: `${key?.condition?.start || key?.condition?.start}||${
            key?.condition?.end || key?.condition?.start
          }`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }

      if (['bounced', 'click'].includes(key?.selector?.value)) {
        if (typeof key?.condition != 'object') {
          return {
            ...key,
            relation: key?.relation?.value,
            selector: key?.selector?.value,
            conditionType: 'string',
          }
        }

        return {
          ...key,
          condition: `${key?.condition?.start || key?.condition?.start}||${
            key?.condition?.end || key?.condition?.start
          }`,
          conditionType: 'range',
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }

      if (['First Name', 'Last Name', 'Address'].includes(key?.selector?.value)) {
        return {
          ...key,
          condition: `${key?.condition}`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }
      if (key?.selector?.value == 'addedThrough') {
        return {
          ...key,
          condition: `${key?.condition?.value}`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }
      if (key?.selector?.value == '') {
        return {...key, relation: key?.relation?.value, selector: key?.selector?.value}
      }

      if (key?.selector?.value == 'Gender') {
        return {
          ...key,
          condition: `${key?.condition?.value}`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }

      if (key?.isDynamicFilter) {
        if (key?.conditionType === 'range') {
          return {
            ...key,
            condition: `${key?.condition?.start || key?.condition?.start}||${
              key?.condition?.end || key?.condition?.start
            }`,
            relation: '',
            selector: key?.selector?.value,
          }
        } else {
          return {
            ...key,
            condition:
              typeof key?.condition === 'string' ? key?.condition : `${key?.condition?.value}`,
            relation: key?.relation?.value,
            selector: key?.selector?.value,
          }
        }
      }

      if (key?.selector?.value == '') {
        return {...key, relation: key?.relation?.value, selector: key?.selector?.value}
      }
    })

    let asd = {...finaldata}
    x?.map((key: any, index: any) => {
      asd[`condition${index + 1}`] = key
    })

    if (Object?.keys(validation(AndOr, x, asd)).length == 0) {
      if (segmentData?._id !== undefined) {
        if (!segmentData?.isReviewed && !segmentData?.isNotCreate) {
          asd = {...asd, isReviewed: true}
        }
        dispatch(UpdateData({data: asd, id: segmentData?._id}))
          .then((res: any) => {
            if (!!segmentData?.isNotCreate) {
              setNewSegmentData(res?.payload?.data?.data)
              dispatch(
                GetFilterContactSegment({
                  id: res?.payload?.data?.data?._id,
                  page: {page: 1, limit: 10},
                })
              )
              handleOpenContects()
            }
          })
          .catch(() => {
            setNewSegmentData({})
          })

        setAndOr({relation1: '', relation2: ''})
        setAddCondition([
          {
            selector: {value: '', label: 'Select'},
            relation: {value: '', label: 'Select'},
            condition: '',
            conditionType: '',
            isDynamicFilter: false,
          },
        ])

        setStartRange('')
        setEndRange('')
        handleClose()
        setSegmentData({})
        setSegName('')
      } else {
        dispatch(CreateData(asd))
          .then((res: any) => {
            setNewSegmentData(res?.payload?.data?.data)
            dispatch(
              GetFilterContactSegment({
                id: res?.payload?.data?.data?._id,
                page: {page: 1, limit: 10},
              })
            )
            handleOpenContects()
          })
          .catch(() => {
            setNewSegmentData({})
          })
        setAndOr({relation1: '', relation2: ''})
        setAddCondition([
          {selector: '', relation: '', condition: '', conditionType: '', isDynamicFilter: false},
        ])

        setStartRange('')
        setEndRange('')
        handleClose()
        setSegName('')
      }
    }
  }

  const validation = (ANDORCondition: any, arrcondition: any, finalObj: any) => {
    let x = arrcondition?.map((key: any, index: number) => {
      if (key?.selector == 'tags') {
        let ids = key?.condition?.map((val: any) => val?.value)
        return {...key, condition: ids}
      }
      if (['createdAt', 'Birthday', 'clickedAt'].includes(key?.selector)) {
        return {
          ...key,
          condition: `${moment(key?.condition?.start).format('YYYY/MM/DD')}||${moment(
            key?.condition?.end
          ).format('YYYY/MM/DD')}`,
        }
      }
      if (['Postal Code', 'Postalcode', 'bounced'].includes(key?.selector)) {
        return {...key, condition: `${key?.condition?.start}||${key?.condition?.end}`}
      }
      if (key?.selector == 'addedThrough') {
        return {...key, condition: ``}
      }
      if (['First Name', 'Last Name', 'Address', 'click', 'Gender'].includes(key?.selector)) {
        return {...key, condition: `${key?.condition}`}
      }
      if (key?.selector == '') {
        return {...key}
      }
    })

    const err: any = {}
    if (finalObj?.name?.trim() == '') {
      err.name = 'Please provide segment name'
    }
    if (ANDORCondition?.relation1 == '' && x?.length == 2) {
      err.rel1 = 'Please select relation'
    }
    if (ANDORCondition?.relation2 == '' && x?.length == 3) {
      err.rel2 = 'Please select relation'
    }
    x?.map((val: any, index: number) => {
      if (val?.selector == '') {
        err[`selector${index}`] = 'please select type of condition'
      }
      if (val?.relation == '') {
        err[`relation${index}`] = 'please select condition'
      }

      if (
        val?.condition == '' &&
        val?.selector == 'tags' &&
        val?.condition?.length == 0 &&
        val?.relation !== ''
      ) {
        err[`condition${index}`] = 'please select condition'
      }
      if (
        ['First Name', 'Last Name', 'Address', 'click', 'Gender'].includes(val?.selector) &&
        val?.condition?.trim() == '' &&
        val?.relation !== ''
      ) {
        err[`condition${index}`] = 'please select condition'
      }
    })

    setError(err)
    return err
  }

  const ConditionsValidation = (addCondition: any) => {
    const err: any = {}

    addCondition?.map((val: any, index: number) => {
      if (val?.[`selector${index}`] == '') {
        err[`selector${index}`] = 'please select type of condition'
      } else {
        err[`selector${index}`] = ''
      }
      if (val?.[`relation${index}`] == '') {
        err[`relation${index}`] = 'please select condition'
      } else {
        err[`relation${index}`] = ''
      }

      if (
        val?.[`condition${index}`] == '' &&
        val?.selector == 'tags' &&
        val?.[`condition${index}`]?.length == 0 &&
        val?.relation !== ''
      ) {
        err[`condition${index}`] = 'please select condition'
      } else {
        err[`condition${index}`] = ''
      }
    })

    setError(err)
    return err
  }

  const ConditionOptions: any = {
    tags: [
      {value: '', label: 'Select'},
      {value: '$in', label: `Is tagged`},
      {value: '$nin', label: `Is not tagged`},
    ],
    Birthday: [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    Address: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `contains`},
      {value: '$ne', label: `does not contain`},
    ],
    Postalcode: [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    'Postal Code': [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    createdAt: [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    'First Name': [
      {value: '', label: 'Select'},
      {value: '$eq', label: `contains`},
      {value: '$ne', label: `does not contain`},
    ],
    'Last Name': [
      {value: '', label: 'Select'},
      {value: '$eq', label: `contains`},
      {value: '$ne', label: `does not contain`},
    ],
    addedThrough: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `was`},
      {value: '$ne', label: `was not`},
    ],
    bounced: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `is`},
      {value: '$gte', label: `Equal to or Greater than`},
      {value: '$in', label: `has in between`},
    ],
    click: [
      {value: '', label: 'Select'},
      {value: '$gte', label: `Equal to or Greater than`},
      {value: '$lt', label: `Equal to or Less than`},
      {value: '$in', label: `has in between`},
    ],
    clickedAt: [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    Gender: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `Equal`},
      {value: '$ne', label: `Not Equal`},
    ],
  }

  const ConditionTypeOptions = [
    {value: '', label: 'Value Type'},
    {value: 'string', label: `String`},
    {value: 'number', label: `Number`},
    {value: 'array', label: `Array`},
    {value: 'boolean', label: `Boolean`},
    {value: 'range', label: `Range`},
  ]

  const DynamicConditionOptions = {
    string: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `Equal`},
      {value: '$ne', label: `Not Equal`},
      {value: '$like', label: `Contains`},
      {value: '$in', label: `Is In`},
      {value: '$nin', label: `is Not In`},
      {value: '$gte', label: `Equal to or Greater than`},
      {value: '$lte', label: `Equal to or Less than`},
    ],
    boolean: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `Equal`},
      {value: '$ne', label: `Not Equal`},
    ],
    number: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `Equal`},
      {value: '$ne', label: `Not Equal`},
      {value: '$like', label: `Contains`},
      {value: '$in', label: `Is In`},
      {value: '$nin', label: `is Not In`},
      {value: '$gte', label: `Equal to or Greater than`},
      {value: '$lte', label: `Equal to or Less than`},
    ],
    array: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `Equal`},
      {value: '$ne', label: `Not Equal`},
      {value: '$in', label: `Is In`},
      {value: '$nin', label: `is Not In`},
    ],
    range: [],
  } as any

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-500px'
        className='vh-100'
        show={show}
        backdrop='static'
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>{segmentData?._id !== undefined ? 'Edit Segment' : 'Create New Segment'}</h2>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              setError({})
              handleClose()
              setAndOr({relation1: '', relation2: ''})
              setAddCondition([
                {
                  selector: {value: '', label: 'Select'},
                  relation: {value: '', label: 'Select'},
                  condition: '',
                  conditionType: '',
                },
              ])
              setStartRange('')
              setEndRange('')
              handleClose()
              setSegmentData({})
              setSegName('')
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-10 pt-5'>
          <label className=' col-form-label required fw-bold fs-6'>Segment Name</label>
          <input
            name='name'
            type='text'
            value={segName}
            onChange={(e: any) => {
              let data = {...error}
              delete data.name
              setSegName(e.target.value)

              e.target.value?.trim() !== ''
                ? setError(data)
                : setError({...error, name: 'Please provide segment name'})
            }}
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='Segment Name'
          />
          <span className='text-danger mb-0'>{error?.name}</span>
          <hr className='mt-10' style={{backgroundColor: '#727272'}} />
          {addCondition?.map((key: any, index: number) => {
            if (index < 3) {
              return (
                <div key={index} className='mb-8 closable-text'>
                  {index !== 0 && (
                    <>
                      {/* TO ADD CONDITION OR AND */}
                      <div className='row mb-2'>
                        <div className='col-sm-6 col-12'>
                          <input
                            type='radio'
                            className='btn-check'
                            name={`TypeOfMsg${index}`}
                            checked={AndOr?.[`relation${index}`] == `$or-${index}`}
                            id={`ORCLICK${index}`}
                            onChange={() => {
                              index == 1
                                ? setAndOr({...AndOr, relation1: '$or-1'})
                                : setAndOr({...AndOr, relation2: '$or-2'})
                            }}
                          />
                          <label
                            className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-2'
                            htmlFor={`ORCLICK${index}`}
                          >
                            <span className='fw-500 fs-5'>OR</span>
                          </label>
                        </div>
                        <div className='col-sm-6 col-12'>
                          <input
                            type='radio'
                            className='btn-check'
                            name={`TypeOfMsg${index}`}
                            checked={AndOr?.[`relation${index}`] == `$and-${index}`}
                            id={`ANDCLICK${index}`}
                            onChange={() => {
                              index == 1
                                ? setAndOr({...AndOr, relation1: `$and-${index}`})
                                : setAndOr({...AndOr, relation2: `$and-${index}`})
                            }}
                          />
                          <label
                            className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-2'
                            htmlFor={`ANDCLICK${index}`}
                          >
                            <span className='fw-500 fs-5'>AND</span>
                          </label>
                        </div>
                      </div>
                      <span className='text-danger'>{error?.[`rel${index}`]}</span>
                    </>
                  )}
                  <div className='d-flex align-items-center'>
                    <label className='mt-3 col-form-label fw-bold fs-6'>{`Condition ${
                      index + 1
                    }`}</label>

                    {/* remove Condition */}
                    {index > 0 && (
                      // <span

                      //   className='bi bi-trash mt-4 ms-4 fs-6'
                      // ></span>
                      <KTSVG
                        onClick={() => {
                          let data = [...addCondition]
                          data?.splice(index, 1)
                          setAddCondition(data)
                          // setAndOr({...AndOr, [`relation${index}`]: ''})
                        }}
                        className='svg-icon-2 mt-2 ms-4'
                        path='/media/icons/duotune/general/gen027.svg'
                      />
                    )}
                  </div>
                  <Select
                    onBlur={() => ConditionsValidation(addCondition)}
                    value={key?.selector}
                    name='selector'
                    onChange={(e: any) => handleChange(e, index)}
                    options={[{value: '', label: 'Select'}, ...SelectorOption]}
                  />
                  <span className='text-danger'>{error[`selector${index}`]}</span>

                  {key?.selector?.value !== '' && key?.isDynamicFilter === false && (
                    <>
                      <Select
                        onBlur={() => ConditionsValidation(addCondition)}
                        value={key?.relation}
                        name='relation'
                        options={ConditionOptions?.[key?.selector?.value]}
                        onChange={(e: any) => handleChangeRelation(e, index)}
                      />
                      <span className='text-danger'>{error?.[`relation${index}`]}</span>
                    </>
                  )}

                  {key?.selector?.value !== '' && key?.isDynamicFilter === true && (
                    <>
                      <Select
                        value={
                          ConditionTypeOptions.find((el) => el.value === key?.conditionType) ||
                          ConditionTypeOptions[0]
                        }
                        name='conditionType'
                        options={ConditionTypeOptions}
                        onChange={(e: any) => handleChangeConditionType(e, index)}
                      />
                      <span className='text-danger'>{error?.[`relation${index}`]}</span>
                    </>
                  )}

                  {key?.selector?.value !== '' &&
                    key?.isDynamicFilter &&
                    key?.conditionType !== '' &&
                    key?.conditionType !== 'range' && (
                      <>
                        <Select
                          value={key?.relation}
                          name='relation'
                          options={DynamicConditionOptions?.[key?.conditionType]}
                          onChange={(e: any) => handleChangeRelation(e, index)}
                        />
                        <span className='text-danger'>{error?.[`relation${index}`]}</span>
                      </>
                    )}

                  {key?.selector?.value == 'tags' && key?.relation?.value !== '' && (
                    <Select
                      // onMenuClose={}
                      onBlur={() => ConditionsValidation(addCondition)}
                      value={key?.condition}
                      options={tagslist?.map((val: any) => ({
                        value: val?._id,
                        label: val?.name,
                      }))}
                      className='bg-light-primary border-0 my-3'
                      isMulti
                      onChange={(e: any) => {
                        handlemultiselect(e, index)
                      }}
                    />
                  )}

                  {key?.selector?.value == 'addedThrough' && key?.relation?.value !== '' && (
                    <Select
                      onBlur={() => ConditionsValidation(addCondition)}
                      value={key?.condition}
                      options={[
                        {value: '', label: 'Select'},
                        {value: 'api', label: 'API'},
                        {value: 'manually', label: 'Upload'},
                        {value: 'wallet', label: 'Wallet'},
                        {value: 'chatbot', label: 'Chatbot'},
                        {value: 'contact', label: 'Contact'},
                        {value: 'other', label: 'Other'},
                      ]}
                      className='form-select bg-light-primary border-0 my-3'
                      onChange={(e: any) => {
                        const updatedData = [...addCondition]
                        updatedData[index] = {
                          ...updatedData[index],
                          condition: e,
                        }
                        setAddCondition(updatedData)
                      }}
                    />
                  )}

                  {['createdAt', 'Birthday', 'clickedAt'].includes(key?.selector?.value) &&
                    key?.relation?.value !== '' && (
                      <div className='datePicker_outer'>
                        <DatePicker
                          placeholderText={
                            key?.relation?.label == 'is in between' ? 'Start Date' : 'Select Date'
                          }
                          value={key?.condition?.start}
                          dateFormat='yyyy/MM/dd'
                          className=' bg-light-primary border-0'
                          selected={key?.condition?.start}
                          onBlur={() => ConditionsValidation(addCondition)}
                          onChange={(date: any) => {
                            const updatedData = [...addCondition]
                            updatedData[index] = {
                              ...updatedData[index],
                              condition: {
                                ...updatedData[index]?.['condition'],
                                start: date,
                                end: date,
                              },
                            }
                            setAddCondition(updatedData)
                          }}
                          selectsStart
                        />

                        {key?.relation?.label == 'is in between' && (
                          <DatePicker
                            placeholderText='End Date'
                            onBlur={() => ConditionsValidation(addCondition)}
                            value={key?.condition?.end}
                            dateFormat='yyyy/MM/dd'
                            className=' bg-light-primary border-0'
                            selected={key?.condition?.end}
                            onChange={(date: any) => {
                              const updatedData = [...addCondition]
                              updatedData[index] = {
                                ...updatedData[index],
                                condition: {
                                  ...updatedData[index]?.['condition'],
                                  end: date,
                                },
                              }
                              setAddCondition(updatedData)
                            }}
                            startDate={key?.condition?.start}
                            minDate={key?.condition?.start}
                            selectsEnd
                          />
                        )}
                      </div>
                    )}

                  {['Postal Code', 'Postalcode'].includes(key?.selector?.value) &&
                    key?.relation?.value !== '' && (
                      <div className='dynamic_field'>
                        <input
                          value={key?.condition?.start}
                          placeholder={
                            key?.relation?.label.includes('in between')
                              ? 'From'
                              : key?.selector?.value
                          }
                          onBlur={() => ConditionsValidation(addCondition)}
                          // onChange={(e: any) => setStartRange(e.target.value)}
                          onChange={(e: any) => {
                            const updatedData = [...addCondition]
                            updatedData[index] = {
                              ...updatedData[index],
                              condition: {
                                ...updatedData[index]?.['condition'],
                                start: e.target.value,
                              },
                            }
                            setAddCondition(updatedData)
                          }}
                        />
                        {key?.relation?.label.includes('in between') && (
                          <input
                            onBlur={() => ConditionsValidation(addCondition)}
                            value={key?.condition?.end}
                            placeholder='To'
                            onChange={(e: any) => {
                              const updatedData = [...addCondition]
                              updatedData[index] = {
                                ...updatedData[index],
                                condition: {
                                  ...updatedData[index]?.['condition'],
                                  end: e.target.value,
                                },
                              }
                              setAddCondition(updatedData)
                            }}
                          />
                        )}
                      </div>
                    )}

                  {['bounced', 'click'].includes(key?.selector?.value) &&
                    key?.relation?.value !== '' && (
                      <>
                        {key?.relation?.label.includes('in between') ? (
                          <div className='dynamic_field'>
                            <input
                              value={key?.condition?.start}
                              placeholder={
                                key?.relation?.label.includes('in between')
                                  ? 'From'
                                  : key?.selector?.value
                              }
                              style={
                                key?.relation?.label.includes('in between')
                                  ? {
                                      width: '100%',
                                    }
                                  : {}
                              }
                              onBlur={() => ConditionsValidation(addCondition)}
                              // onChange={(e: any) => setStartRange(e.target.value)}
                              onChange={(e: any) => {
                                const updatedData = [...addCondition]
                                updatedData[index] = {
                                  ...updatedData[index],
                                  condition: {
                                    ...updatedData[index]?.['condition'],
                                    start: e.target.value,
                                  },
                                }
                                setAddCondition(updatedData)
                              }}
                            />
                            {key?.relation?.label.includes('in between') && (
                              <input
                                style={
                                  key?.relation?.label.includes('in between')
                                    ? {
                                        width: '100%',
                                      }
                                    : {}
                                }
                                onBlur={() => ConditionsValidation(addCondition)}
                                value={key?.condition?.end}
                                placeholder='To'
                                onChange={(e: any) => {
                                  const updatedData = [...addCondition]
                                  updatedData[index] = {
                                    ...updatedData[index],
                                    condition: {
                                      ...updatedData[index]?.['condition'],
                                      end: e.target.value,
                                    },
                                  }
                                  setAddCondition(updatedData)
                                }}
                              />
                            )}
                          </div>
                        ) : (
                          <div className='dynamic_field'>
                            <input
                              value={key?.condition}
                              placeholder={key?.selector?.value}
                              onBlur={() => ConditionsValidation(addCondition)}
                              // onChange={(e: any) => setStartRange(e.target.value)}
                              onChange={(e: any) => {
                                const updatedData = [...addCondition]
                                updatedData[index] = {
                                  ...updatedData[index],
                                  condition: e.target.value,
                                }
                                setAddCondition(updatedData)
                              }}
                            />
                          </div>
                        )}
                      </>
                    )}

                  {['First Name', 'Address', 'Last Name'].includes(key?.selector?.value) &&
                    key?.relation?.value !== '' && (
                      <div className='dynamic_field'>
                        <input
                          onBlur={() => ConditionsValidation(addCondition)}
                          value={key?.condition}
                          className='form-input'
                          onChange={(e: any) => {
                            const updatedData = [...addCondition]
                            updatedData[index] = {
                              ...updatedData[index],
                              condition: e.target.value,
                            }
                            setAddCondition(updatedData)
                          }}
                          placeholder={key?.selector?.value}
                        />
                      </div>
                    )}

                  {key?.selector?.value == 'Gender' && key?.relation?.value !== '' && (
                    <Select
                      onBlur={() => ConditionsValidation(addCondition)}
                      value={key?.condition}
                      options={[
                        {value: '', label: 'Select'},
                        {value: 'M', label: 'Male'},
                        {value: 'F', label: 'Female'},
                      ]}
                      className='form-select bg-light-primary border-0 my-3'
                      onChange={(e: any) => {
                        const updatedData = [...addCondition]
                        updatedData[index] = {
                          ...updatedData[index],
                          condition: e,
                        }
                        setAddCondition(updatedData)
                      }}
                    />
                  )}

                  {key?.isDynamicFilter &&
                    key?.relation?.value !== '' &&
                    ['string', 'number', 'array'].includes(key?.conditionType) && (
                      <div className='dynamic_field'>
                        <input
                          onBlur={() => ConditionsValidation(addCondition)}
                          value={key?.condition}
                          className='form-input'
                          onChange={(e: any) => {
                            const updatedData = [...addCondition]
                            updatedData[index] = {
                              ...updatedData[index],
                              condition: e.target.value,
                            }
                            setAddCondition(updatedData)
                          }}
                          placeholder={key?.selector?.value}
                        />
                      </div>
                    )}

                  {key?.isDynamicFilter && key?.conditionType === 'range' && (
                    <div className='dynamic_field'>
                      <input
                        value={key?.condition?.start}
                        placeholder={'From'}
                        style={{
                          width: '100%',
                        }}
                        onBlur={() => ConditionsValidation(addCondition)}
                        // onChange={(e: any) => setStartRange(e.target.value)}
                        onChange={(e: any) => {
                          const updatedData = [...addCondition]
                          updatedData[index] = {
                            ...updatedData[index],
                            condition:
                              typeof updatedData[index]?.['condition'] === 'object'
                                ? {
                                    ...updatedData[index]?.['condition'],
                                    start: e.target.value,
                                  }
                                : {
                                    end: updatedData[index]?.['condition']?.end || '',
                                    start: e.target.value,
                                  },
                          }
                          setAddCondition(updatedData)
                        }}
                      />

                      <input
                        style={{
                          width: '100%',
                        }}
                        onBlur={() => ConditionsValidation(addCondition)}
                        value={key?.condition?.end}
                        placeholder='To'
                        onChange={(e: any) => {
                          const updatedData = [...addCondition]
                          updatedData[index] = {
                            ...updatedData[index],
                            condition:
                              typeof updatedData[index]?.['condition'] === 'object'
                                ? {
                                    ...updatedData[index]?.['condition'],
                                    end: e.target.value,
                                  }
                                : {
                                    start: updatedData[index]?.['condition']?.start || '',
                                    end: e.target.value,
                                  },
                          }
                          setAddCondition(updatedData)
                        }}
                      />
                    </div>
                  )}

                  {key?.isDynamicFilter &&
                    key?.relation?.value !== '' &&
                    key?.conditionType === 'boolean' && (
                      <Select
                        onBlur={() => ConditionsValidation(addCondition)}
                        value={key?.condition}
                        options={[
                          {value: '', label: 'Select'},
                          {value: 'true', label: 'True'},
                          {value: 'false', label: 'False'},
                        ]}
                        className='form-select bg-light-primary border-0 my-3'
                        onChange={(e: any) => {
                          const updatedData = [...addCondition]
                          updatedData[index] = {
                            ...updatedData[index],
                            condition: e,
                          }
                          setAddCondition(updatedData)
                        }}
                      />
                    )}
                  <span className='text-danger'>{error?.[`condition${index}`]}</span>
                </div>
              )
            }
          })}
          <button
            className='btn w-100 gray_bg_purple'
            disabled={addCondition?.length == 3}
            onClick={() => {
              setAddCondition([
                ...addCondition,
                {
                  selector: {value: '', label: 'select'},
                  relation: {value: '', label: 'select'},
                  condition: null,
                  conditionType: '',
                },
              ])
            }}
          >
            {' '}
            <i className='bi bi-plus'></i>
            Add another condition
          </button>
          <div className='d-flex justify-content-end mt-10'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={() => {
                  setError({})
                  handleClose()
                  setAndOr({relation1: '', relation2: ''})
                  setAddCondition([
                    {
                      selector: {value: '', label: 'Select'},
                      relation: {value: '', label: 'Select'},
                      condition: '',
                      conditionType: '',
                    },
                  ])

                  setStartRange('')
                  setEndRange('')
                  handleClose()
                  setSegmentData({})
                  setSegName('')
                }}
                className='btn btn-sm gray_bg_purple me-2 w-100px p-3 fw-500 me-2'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500 p-3 px-7 border border-primary'
              onClick={handleSubmit}
            >
              <span className='indicator-label'>Review segment</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateSegmentPopup
